import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import styled from "styled-components";

export const ToggleButtonGroupComponent = styled(ToggleButtonGroup)`
  display: flex;
  gap: 0;
`;

export const ToggleButtonComponent = styled(ToggleButton)`
  && {
    text-transform: none;
    font-weight: 500;
    padding: 6px 16px;
    font-size: 0.875rem;
    border: 2px solid ${(props) => props.theme.primary.original};
    background-color: white;
    border-radius: 4px;
    color: ${(props) => props.theme.primary.original};

    &:hover {
      color: white;
      background-color: ${(props) => props.theme.primary.dark};
    }

    &.Mui-selected {
      color: white;
      background-color: ${(props) => props.theme.primary.original};
      pointer-events: none;

      &:hover {
        background-color: ${(props) => props.theme.primary.original};
        transform: none;
      }
    }

    &.Mui-disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`;
